import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BRAND, NAV_LINKS } from "../../data/content";

export const Header = () => {
const [open, setOpen] = useState(false);
const [openServices, setOpenServices] = useState(false);
const [openMedia, setOpenMedia] = useState(false);
const [openAbout, setOpenAbout] = useState(false);
const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToAnchor = (e, id) => {
    e.preventDefault();
    setOpen(false);
    if (isHome) {
      const el = document.getElementById(id);
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  // Handle hash on landing
  useEffect(() => {
    if (isHome && location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [isHome, location.hash]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-[color:var(--bg)]/85 backdrop-blur-xl border-b border-soft"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img
  src="/images/logo.png"
  alt="Baba Tour"
  className="w-20 h-20 object-contain"
/>

<div className="leading-tight">
  <div className="font-serif-display text-2xl font-bold text-primary">
    BABA TOUR
  </div>

  <div className="text-sm font-medium text-main">
    Umroh dan Haji Khusus
  </div>

<div className="text-xs mt-1 font-semibold tracking-wide text-accent">
  PPIU • PIHK • Provider Visa
</div>

</div>

        </Link>

<nav className="hidden lg:flex items-center gap-7">

  <a
    href="/#home"
    onClick={(e) => goToAnchor(e, "home")}
    className="text-sm text-main hover:text-accent transition-colors"
  >
    Home
  </a>

  <a
    href="/#packages"
    onClick={(e) => goToAnchor(e, "packages")}
    className="text-sm text-main hover:text-accent transition-colors"
  >
    Paket Umroh
  </a>

  <a
    href="/#haji-khusus"
    onClick={(e) => goToAnchor(e, "haji-khusus")}
    className="text-sm text-main hover:text-accent transition-colors"
  >
    Haji Khusus
  </a>

  <div className="relative group">
    <button className="text-sm text-main hover:text-accent transition-colors">
      Layanan Khusus
    </button>

    <div className="absolute left-0 top-full hidden group-hover:block bg-white shadow-lg rounded-xl py-2 min-w-[220px]">

<a
  href="/#visa-umroh"
  onClick={(e) => goToAnchor(e, "visa-umroh")}
  className="block px-4 py-2 hover:bg-gray-50"
>
  Visa Umroh
</a>
<a
  href="/#umroh-custom"
  onClick={(e) => goToAnchor(e, "umroh-custom")}
className="block px-4 py-2 hover:bg-gray-50"
>
  Umroh Custom
</a>
    </div>
  </div>

<div className="relative group">
    <button className="text-sm text-main hover:text-accent transition-colors">
      Media & Informasi
    </button>

    <div className="absolute left-0 top-full hidden group-hover:block bg-white shadow-lg rounded-xl py-2 min-w-[220px]">

<a
  href="/#gallery"
  onClick={(e) => goToAnchor(e, "gallery")}
  className="block px-4 py-2 hover:bg-gray-50"
>
  Galeri
</a>
<a
  href="/#blog"
  onClick={(e) => goToAnchor(e, "blog")}
className="block px-4 py-2 hover:bg-gray-50"
>
  Artikel
</a>
<a
  href="/#faq"
  onClick={(e) => goToAnchor(e, "faq")}
className="block px-4 py-2 hover:bg-gray-50"
>
  FAQ
</a>
    </div>
  </div>


  <div className="relative group">
    <button className="text-sm text-main hover:text-accent transition-colors">
      Tentang
    </button>

    <div className="absolute left-0 top-full hidden group-hover:block bg-white shadow-lg rounded-xl py-2 min-w-[220px]">

      <a
        href="/#about"
        className="block px-4 py-2 hover:bg-gray-50"
      >
        Tentang Kami
      </a>

      <a
        href="/#why-us"
        className="block px-4 py-2 hover:bg-gray-50"
      >
        Mengapa Baba Tour
      </a>

      <a
        href="/#layanan"
        className="block px-4 py-2 hover:bg-gray-50"
      >
        Layanan Baba Tour
      </a>

      <a
        href="/#testimonials"
        className="block px-4 py-2 hover:bg-gray-50"
      >
        Testimoni
      </a>

    </div>
  </div>


</nav>
        <div className="hidden lg:flex items-center">
          <a
            href="/#footer"
            onClick={(e) => goToAnchor(e, "footer")}
            data-testid="header-cta-btn"
            className="bg-primary text-white hover:bg-primary/90 transition-colors rounded-full px-6 py-3 text-sm font-medium"
          >
            Daftar Sekarang
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          aria-label="menu"
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-primary"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-soft bg-[color:var(--bg)]">
          <div className="px-6 py-6 flex flex-col gap-4">
<a
  href="/#home"
  onClick={(e) => goToAnchor(e, "home")}
  className="text-base text-main hover:text-accent"
>
  Home
</a>

<a
  href="/#packages"
  onClick={(e) => goToAnchor(e, "packages")}
  className="text-base text-main hover:text-accent"
>
  Paket Umroh
</a>

<a
  href="/#haji-khusus"
  onClick={(e) => goToAnchor(e, "haji-khusus")}
  className="text-base text-main hover:text-accent"
>
  Haji Khusus
</a>

<div className="pt-2 border-t border-soft">

  <button
onClick={() => {
setOpenServices(!openServices);
  setOpenMedia(false);
  setOpenAbout(false);
}}
    className="w-full flex items-center justify-between font-semibold text-primary"
  >
    <span>Layanan Khusus</span>
    <span>{openServices ? "▲" : "▼"}</span>
  </button>

  {openServices && (
    <div className="mt-2 space-y-2">
<a
  href="/#visa-umroh"
  onClick={(e) => goToAnchor(e, "visa-umroh")}
        className="block pl-4 text-main"
      >
        Visa Umroh
     </a>
<a
  href="/#umroh-custom"
  onClick={(e) => goToAnchor(e, "umroh-custom")}        className="block pl-4 text-main"
      >
        Umroh Custom
</a>

    </div>
  )}

</div>

<div className="pt-2 border-t border-soft">

  <button
onClick={() => {
setOpenMedia(!openMedia);
  setOpenServices(false);
  setOpenAbout(false);
}}
    className="w-full flex items-center justify-between font-semibold text-primary"
  >
    <span>Informasi & Media</span>
<span>{openMedia ? "▲" : "▼"}</span>
  </button>

  {openMedia && (
    <div className="mt-2 space-y-2">
<a
  href="/#gallery"
  onClick={(e) => goToAnchor(e, "gallery")}
        className="block pl-4 text-main"
      >
        Galeri
     </a>
<a
  href="/#blog"
  onClick={(e) => goToAnchor(e, "blog")}        className="block pl-4 text-main"
      >
        Artikel
</a>
<a
  href="/#faq"
  onClick={(e) => goToAnchor(e, "faq")}        className="block pl-4 text-main"
      >
        FAQ
</a>
    </div>
  )}

</div>

<div className="border-t border-soft pt-2">

  <button
onClick={() => {
setOpenAbout(!openAbout);
  setOpenServices(false);
  setOpenMedia(false);
}}
    className="w-full flex items-center justify-between font-semibold text-primary"
  >
    <span>Tentang</span>
    <span>{openAbout ? "▲" : "▼"}</span>
  </button>

  {openAbout && (
    <div className="mt-2 space-y-2">

      <a
        href="/#about"
        onClick={(e) => goToAnchor(e, "about")}
        className="block pl-4 text-main"
      >
        Tentang Kami
      </a>

      <a
        href="/#why-us"
        onClick={(e) => goToAnchor(e, "why-us")}
        className="block pl-4 text-main"
      >
        Mengapa Baba Tour
      </a>

      <a
        href="/#layanan"
        onClick={(e) => goToAnchor(e, "layanan")}
        className="block pl-4 text-main"
      >
        Layanan Baba Tour
      </a>

      <a
        href="/#testimonials"
        onClick={(e) => goToAnchor(e, "testimonials")}
        className="block pl-4 text-main"
      >
        Testimoni
      </a>

    </div>
  )}

</div>
            <a
              href="/#footer"
              onClick={(e) => goToAnchor(e, "footer")}
              data-testid="mobile-header-cta-btn"
              className="bg-primary text-white text-center rounded-full px-6 py-3 text-sm font-medium"
            >
              Daftar Sekarang
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
